import React from 'react';
import brFlag from '../images/br.png';
import esFlag from '../images/es.png';
import usFlag from '../images/us.png';
import i18n from '../i18n';
import Box from "@mui/material/Box";
import { Tooltip } from '@mui/material';


const LanguageSelector = ({ position = 'top-right' }) => {
  const handleChangeLanguage = (code) => {
    localStorage.setItem('lang', code);
    i18n.changeLanguage(code);
  };


  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
        <Tooltip title="Português">
            <img
             src={brFlag}
             alt="Português"
             width={24}
             style={{ cursor: 'pointer' }}
             onClick={() => handleChangeLanguage('pt-BR')}
            />
        </Tooltip>
        <Tooltip title="Español">
            <img
              src={esFlag}
              alt="Español"
              width={24}
              style={{ cursor: 'pointer' }}
              onClick={() => handleChangeLanguage('es')}
            />
        </Tooltip>
        <Tooltip title="English">
            <img
              src={usFlag}
              alt="English"
              width={24}
              style={{ cursor: 'pointer' }}
              onClick={() => handleChangeLanguage('en')}
            />
       </Tooltip>
    </Box>
  );
};

export default LanguageSelector;
